// Update contents object below
const contents = {
  header: 'AWS Intel', //update with your client name
  logoTooltip: {
    href: '', //where the logo click drives to
    copy: '' // tooltip content
  },
  hero: {
    background: 'image', //options: "image" or "video"
    logoPlacement: 'top', //options: "top" or "center"
    title: 'How Technology Improves Human Experiences',
    copy: 'Industry leaders do more than iterate, they reinvent.'
  },
  inlinePhotos: {
    size: 'bodyWidth', //options: "fullBleed" or "bodyWidth"
    contents: [
      { class: 'photo1', caption: 'caption' },
      { class: 'photo2', caption: 'caption' },
      { class: 'photo3', caption: 'caption' },
      { class: 'photo4', caption: 'caption' },
      { class: 'photo5', caption: 'caption' },
      { class: 'photo6', caption: 'caption' },
      { class: 'photo7', caption: 'caption' },
      { class: 'photo8', caption: 'caption' }
    ] //add more objects in the array if you have more than one photo
  },
  ctaTooltip: {
    href:
      'https://aws.amazon.com/intel/?trk=461cf245-3964-48b5-80ec-92d006d9f622&sc_channel=display%20ads?utm_source=cnn&utm_medium=hyperlink&utm_campaign=gc-ngitl&utm_content=infrastructureinnovation_article&utm_creative=link', //where the cta button click drives to
    copy: 'https://aws.amazon.com/intel/' //tooltip content
  },
  pullQuoteContent: {
    pullQuote1:
      'Players who achieve extremely high scores in the app sometimes even get a chance to connect with a professional sports club for a tryout. “We’ve actually had a player who has done drills and had a call from the club on the same day. It’s happened that quickly,” says Richard Felton-Thomas, Director of Sport Science and COO at AiSCOUT. “It’s incredibly rewarding when a player gets signed who might never have been seen otherwise. It’s heartwarming, and it’s also a validation for the ability of this technology to change someone’s life.”',
    pullQuote2:
      'In fact, the program was such a huge success that India announced that it would make the Co-WIN platform open source so that all countries could save lives and protect health with a modern, cloud-based vaccine registration platform.'
  }
};

export default contents;
